'use client'

import * as TabsPrimitive from '@radix-ui/react-tabs'
import * as React from 'react'

import { cn } from '../../utils/cn'

function SegmentedTabsList({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      data-slot="segmented-tabs-list"
      className={cn('gap-xs inline-flex w-fit items-center', className)}
      {...props}
    />
  )
}

/**
 * Segmented trigger styles, keyed off `data-state`. Exported so a segmented control that cannot
 * be Radix Tabs (a multi-select filter row, say) reuses these instead of copying them.
 */
const segmentedTabsTriggerClassName = cn(
  'text-foreground text-3xs cursor-pointer rounded-lg border-[0.5px] border-transparent px-2.5 py-1 transition-all',
  'hover:bg-muted active:bg-muted/90 hover:brightness-105 active:brightness-100',
  'data-[state=active]:border-[0.5px] data-[state=active]:border-border data-[state=active]:bg-secondary data-[state=active]:shadow-sm data-[state=active]:hover:bg-accent data-[state=active]:active:bg-accent',
  'dark:data-[state=active]:border-transparent dark:data-[state=active]:bg-secondary dark:data-[state=active]:shadow-none dark:data-[state=active]:hover:bg-secondary dark:data-[state=active]:active:bg-secondary/80'
)

function SegmentedTabsTrigger({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
  return (
    <TabsPrimitive.Trigger
      data-slot="segmented-tabs-trigger"
      className={cn(segmentedTabsTriggerClassName, className)}
      {...props}
    />
  )
}

export { SegmentedTabsList, segmentedTabsTriggerClassName, SegmentedTabsTrigger }
